import { memo, MouseEvent, useCallback } from "react";
import { clsx } from "clsx";
import styled from "styled-components";

import { Icon } from "@/shared/ui/Icon";
import { Img } from "@/shared/ui/Img";
import { Skeleton } from "@/shared/ui/Skeleton";

import profileIcon from "@/shared/assets/accountPink.svg";

import cls from "./UserPicture.module.scss";

interface UserPictureProps {
  onClick?: (event: MouseEvent) => void;
  className?: string;
  src?: string | null;
  size?: number;
  variant?: "dark" | "light";
}

export const UserPicture = memo((props: UserPictureProps) => {
  const { className, src, size, onClick, variant = "dark" } = props;

  const onContextMenu = useCallback((e) => {
    e.preventDefault();
  }, []);

  if (src) {
    const fallback = <Skeleton width={size ?? 48} height={size ?? 48} borderRadius={(size ?? 48) / 2} />;
    return (
      <Img
        style={{
          width: `${size ?? 48}px`,
          minWidth: `${size ?? 48}px`,
          height: `${size ?? 48}px`,
        }}
        className={clsx(cls.Img, {}, [className])}
        src={src}
        onClick={onClick}
        onContextMenu={onContextMenu}
        fallback={fallback}
      />
    );
  }

  return (
    <Placeholder className={className} onClick={onClick} size={size}>
      <Icon className={cls.Icon} Svg={profileIcon} width={size ? size - 16 : 34} height={size ? size - 16 : 34} />
    </Placeholder>
  );
});

const Placeholder = styled("div")<{ size?: number }>`
  min-height: ${(p) => p.size ?? "48"}px;
  height: ${(p) => p.size ?? "48"}px;
  min-width: ${(p) => p.size ?? "48"}px;
  width: ${(p) => p.size ?? "48"}px;
  background: var(--color-magenta);
  background: linear-gradient(135deg, rgba(191, 24, 132, 1) 0%, rgba(191, 24, 132, 1) 17%, rgba(21, 15, 86, 1) 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  font-size: 0;
  color: var(--color-magenta);
`;
